export default __webpack_public_path__ + "8e306dc080ec18257abdc430274966ce.png";